var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUscgSafetyWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7398 27.59H15.2698C14.4798 27.59 13.9098 27.56 13.4198 27.49C9.94977 27.11 9.25977 25.03 9.25977 21.58V15.26C9.25977 11.81 9.93977 9.72998 13.4398 9.34998C13.9198 9.27998 14.4898 9.25 15.2698 9.25H24.7398C25.5198 9.25 26.0898 9.27998 26.5898 9.34998C30.0698 9.72998 30.7498 11.81 30.7498 15.26V21.58C30.7498 25.03 30.0698 27.11 26.5698 27.49C26.0998 27.56 25.5298 27.59 24.7398 27.59ZM15.2598 10.75C14.5498 10.75 14.0398 10.78 13.6198 10.84C11.4598 11.08 10.7498 11.75 10.7498 15.27V21.59C10.7498 25.1 11.4598 25.78 13.5998 26.01C14.0398 26.07 14.5498 26.1 15.2698 26.1H24.7398C25.4598 26.1 25.9598 26.07 26.3798 26.01C28.5398 25.77 29.2498 25.1 29.2498 21.58V15.26C29.2498 11.75 28.5398 11.07 26.3998 10.84C25.9498 10.78 25.4498 10.75 24.7298 10.75H15.2598Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2601 17.0703H21.5801C21.1701 17.0703 20.8301 16.7303 20.8301 16.3203C20.8301 15.9103 21.1701 15.5703 21.5801 15.5703H25.2601C25.6701 15.5703 26.0101 15.9103 26.0101 16.3203C26.0101 16.7303 25.6801 17.0703 25.2601 17.0703Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.3203C17.45 17.3203 17 16.8703 17 16.3203C17 15.7703 17.44 15.3203 18 15.3203C18.55 15.3203 19 15.7703 19 16.3203C19 16.8703 18.56 17.3203 18 17.3203Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 17.3203C14.3001 17.3203 13.8501 16.8703 13.8501 16.3203C13.8501 15.7703 14.2901 15.3203 14.8501 15.3203H14.8601C15.4101 15.3203 15.8601 15.7703 15.8601 16.3203C15.8601 16.8703 15.4001 17.3203 14.8501 17.3203Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2602 22.8599H14.7502C14.3402 22.8599 13.9902 22.5199 13.9902 22.1099C13.9902 21.6999 14.3202 21.3599 14.7302 21.3599H25.2602C25.6702 21.3599 26.0102 21.6999 26.0102 22.1099C26.0102 22.5199 25.6802 22.8599 25.2602 22.8599Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.75H15C14.59 30.75 14.25 30.41 14.25 30C14.25 29.59 14.59 29.25 15 29.25H25C25.41 29.25 25.75 29.59 25.75 30C25.75 30.41 25.41 30.75 25 30.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUscgSafetyWrapper);
export default __webpack_public_path__ + "static/media/uscg-safety-wrapper.e1f60f42dc5ffe9811cf7357b278dadc.svg";
export { ForwardRef as ReactComponent };